import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GuruLayout from "../../components/layout/GuruLayout";

import { 
  FaUserCircle, 
  FaCamera, 
  FaCalendarCheck, 
  FaChartLine, 
  FaCloudDownloadAlt, 
  FaTimes 
} from "react-icons/fa";

export default function PetunjukGuru() {
  const [showModal, setShowModal] = useState(false);
  const [openFeature, setOpenFeature] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setShowModal(true);
  }, []);

  const petunjukFitur = [
    {
      nama: "Petunjuk Umum & Profil",
      icon: <FaUserCircle className="text-blue-500 text-base" />,
      langkah: [
        "Masuk ke sistem menggunakan akun guru yang telah terdaftar.",
        "Setelah login, lengkapi profil Anda sebelum menggunakan fitur sistem.",
        "Gunakan menu sidebar untuk mengakses seluruh fitur utama SIPENSA.",
        "Gunakan menu Profil untuk melihat dan memperbarui data akun Anda.",
        "Setelah selesai menggunakan sistem, Anda dapat kembali ke dashboard atau logout dari akun."
      ],
      infoTambahan: "Pastikan Anda telah melengkapi data pada menu Profil sebelum menggunakan sistem secara penuh."
    },
    {
      nama: "Fitur Presensi Siswa",
      icon: <FaCamera className="text-green-500 text-base" />,
      langkah: [
        "Masuk ke menu Presensi untuk melakukan pencatatan kehadiran siswa.",
        "Pilih kelas dan jadwal sesuai dengan waktu mengajar Anda.",
        "Pilih metode presensi yang tersedia (scan kartu atau input manual).",
        "Jika menggunakan scan kartu, arahkan kamera ke kartu siswa (QR Code) dengan posisi jelas dan tidak blur.",
        "Pastikan kartu berada dalam frame kamera hingga sistem berhasil membaca data siswa.",
        "Periksa hasil presensi (hadir, izin, sakit, alfa) sebelum disimpan.",
        "Klik tombol simpan untuk menyimpan data presensi."
      ],
      infoTambahan: "Jika kamera bermasalah atau ruang kelas kurang pencahayaan, silakan gunakan metode presensi manual."
    },
    {
      nama: "Fitur Jadwal Mengajar",
      icon: <FaCalendarCheck className="text-orange-500 text-base" />,
      langkah: [
        "Buka menu Jadwal melalui sidebar di sebelah kiri.",
        "Lihat daftar jadwal mengajar Anda yang telah ditentukan oleh admin sekolah.",
        "Jika Anda berhalangan hadir, klik pada jadwal terkait lalu pilih opsi 'Lapor Izin' agar guru lain dapat menggantikan.",
        "Jika Anda memiliki waktu luang dan ingin mengajar, Anda dapat melihat daftar 'Jadwal Kosong' yang diajukan guru lain.",
        "Pilih jadwal kosong yang tersedia, lalu klik 'Ambil Jadwal' untuk mengisi jam pelajaran tersebut.",
        "Pastikan jam dan kelas sudah sesuai pada sistem sebelum Anda memulai kelas pengganti."
      ],
      infoTambahan: "Setiap pengajuan atau pengambilan jadwal kosong akan tercatat secara otomatis pada sistem."
    },
    {
      nama: "Fitur Monitoring Kehadiran",
      icon: <FaChartLine className="text-purple-500 text-base" />,
      langkah: [
        "Masuk ke menu Monitoring Kehadiran.",
        "Menu ini digunakan untuk melihat data kehadiran siswa secara langsung (real-time).",
        "Anda bisa memantau siswa siapa saja yang belum atau sudah hadir hari ini."
      ]
    },
    {
      nama: "Fitur Rekapitulasi Data",
      icon: <FaCloudDownloadAlt className="text-teal-500 text-base" />,
      langkah: [
        "Masuk ke menu Rekapitulasi pada sidebar.",
        "Menu ini digunakan untuk melihat rangkuman data presensi siswa dalam periode tertentu.",
        "Anda dapat mengunduh rekap data presensi tersebut untuk laporan bulanan."
      ],
      infoTambahan: "Rekap presensi dapat diunduh dalam format berkas yang sudah disediakan oleh sistem."
    }
  ];

  const toggleFeature = (index) => {
    setOpenFeature(openFeature === index ? null : index);
  };

  const handleClose = () => {
    setShowModal(false);
    navigate("/guru");
  };

  const handlePresensi = () => {
    setShowModal(false);
    navigate("/guru/presensi");
  };

  return (
    <GuruLayout>
      <div className="p-4 sm:p-6">

        {showModal && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-2 sm:p-4">
            
            <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl flex flex-col max-h-[90vh] animate-in fade-in zoom-in duration-300">
              
              {/* Header */}
              <div className="px-4 sm:px-6 py-3 sm:py-4 border-b bg-blue-600 text-white flex justify-between items-center shrink-0">
                <h3 className="text-base sm:text-lg font-bold">
                  Petunjuk Penggunaan SIPENSA (Guru)
                </h3>
                <button 
                  onClick={handleClose} 
                  className="p-1 rounded-lg hover:bg-blue-700 text-xl transition-colors flex items-center justify-center"
                >
                  <FaTimes />
                </button>
              </div>

              {/* Content / Daftar Fitur Kebawah */}
              <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-4 space-y-3">
                <p className="text-xs text-gray-500 font-medium mb-2">Silakan pilih fitur untuk melihat petunjuk penggunaan:</p>

                {petunjukFitur.map((fitur, idx) => {
                  const isOpen = openFeature === idx;
                  return (
                    <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50/50">
                      
                      <button
                        onClick={() => toggleFeature(idx)}
                        className={`w-full px-4 py-3 flex justify-between items-center font-semibold text-sm transition-colors text-left ${
                          isOpen ? "bg-blue-50 text-blue-700" : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          {fitur.icon}
                          <span>{fitur.nama}</span>
                        </span>
                        
                        <svg
                          className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? "rotate-180 text-blue-600" : "text-gray-400"}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      {isOpen && (
                        <div className="p-4 bg-white border-t border-gray-100 space-y-3">
                          {fitur.langkah.map((isiLangkah, langkahIdx) => (
                            <div key={langkahIdx} className="flex gap-3 items-start">
                              <span className="text-blue-600 font-bold text-sm min-w-[18px]">
                                {langkahIdx + 1}.
                              </span>
                              <span className="text-gray-600 text-sm leading-relaxed">
                                {isiLangkah}
                              </span>
                            </div>
                          ))}

                          {fitur.infoTambahan && (
                            <div className="mt-2 p-3 bg-yellow-50 border-l-4 border-yellow-400 text-xs text-gray-700 rounded-r">
                              {fitur.infoTambahan}
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  );
                })}
              </div>

              {/* Footer */}
              <div className="px-4 py-3 bg-gray-50 border-t flex gap-2 shrink-0">
                <button
                  onClick={handleClose}
                  className="w-1/2 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm font-medium transition-colors"
                >
                  Saya Mengerti
                </button>

                <button
                  onClick={handlePresensi}
                  className="w-1/2 bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg text-sm font-medium transition-colors"
                >
                  Lanjut Presensi
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </GuruLayout>
  );
}